// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {},
//   getters: {},
//   mutations: {},
//   actions: {},
//   modules: {}
// })

import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import device from './modules/device'
import historyData from './modules/historyData'
import realTimeData from './modules/realTimeData'
import stateData from './modules/stateData'
// import route from './modules/route'
import getters from './getters'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    device,
    historyData,
    realTimeData,
    stateData
    // route
  },
  getters
  // plugins: [createPersistedState()]
})

export default store
